import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { format, addDays, subDays } from 'date-fns';
import api from '../api';

function DailyEditor() {
  const { date } = useParams();
  const today = format(new Date(), 'yyyy-MM-dd');
  const currentDate = date || today;

  const [entry, setEntry] = useState({ content: '', mood: '', weather: '', song: '' });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get(`/daily/${currentDate}`)
      .then(({ data }) => {
        setEntry({
          content: data.entry.content || '',
          mood: data.entry.mood || '',
          weather: data.entry.weather || '',
          song: data.entry.song || ''
        });
      })
      .catch(() => {});
  }, [currentDate]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put(`/daily/${currentDate}`, entry);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  const prevDate = format(subDays(new Date(currentDate + 'T00:00:00'), 1), 'yyyy-MM-dd');
  const nextDate = format(addDays(new Date(currentDate + 'T00:00:00'), 1), 'yyyy-MM-dd');
  const displayDate = format(new Date(currentDate + 'T00:00:00'), 'EEEE, MMMM d, yyyy');

  return (
    <div>
      <div className="admin-header">
        <h1>Daily Entry</h1>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {saved && <span style={{ fontSize: '0.8rem', color: 'var(--sage)' }}>saved</span>}
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? '...' : 'Save'}
          </button>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <a href={`/admin/day/${prevDate}`} className="btn btn-ghost">&larr;</a>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.72rem', color: 'var(--text-muted)', letterSpacing: '1px', textTransform: 'uppercase' }}>
            {displayDate}
          </div>
        </div>
        <a href={`/admin/day/${nextDate}`} className="btn btn-ghost">&rarr;</a>
      </div>

      <div className="form-group">
        <textarea
          className="form-input"
          placeholder="What happened today? How do you feel? Just write..."
          value={entry.content}
          onChange={(e) => setEntry({ ...entry, content: e.target.value })}
          rows={10}
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
        <div className="form-group">
          <label className="form-label">Mood</label>
          <select className="form-input" value={entry.mood} onChange={(e) => setEntry({ ...entry, mood: e.target.value })}>
            <option value="">...</option>
            {['happy', 'calm', 'grateful', 'reflective', 'anxious', 'sad', 'tired', 'excited', 'inspired', 'nostalgic', 'confused', 'peaceful'].map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Weather</label>
          <select className="form-input" value={entry.weather} onChange={(e) => setEntry({ ...entry, weather: e.target.value })}>
            <option value="">...</option>
            {['sunny', 'cloudy', 'rainy', 'stormy', 'cold', 'hot', 'windy', 'snowy', 'perfect'].map(w => (
              <option key={w} value={w}>{w}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Song of the day</label>
          <input
            type="text" className="form-input"
            placeholder="what's playing"
            value={entry.song}
            onChange={(e) => setEntry({ ...entry, song: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
}

export default DailyEditor;
